exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-item-inner {\n  width: 100%;\n  padding: 8px 15px 7px 0px;\n}\n.paymentsRequestSubOption {\n  font-size: 14px;\n}\n.paymentsRequestSubOption input::-webkit-input-placeholder {\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a0ebfc4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/creationPages/DDCreateTemplate.vue
// module id = 1524
// module chunks = 2